import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=4b883ae4&scoped=true"
import script from "./SidebarMobile.vue?vue&type=script&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&lang=js"
import style0 from "./SidebarMobile.vue?vue&type=style&index=0&id=4b883ae4&prod&lang=scss&scoped=true"
import style1 from "./SidebarMobile.vue?vue&type=style&index=1&id=4b883ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b883ae4",
  null
  
)

export default component.exports